import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
  CardMedia,
  Typography,
  Switch,
  FormControlLabel,
  IconButton,
} from '@mui/material';
import { Close, CloudUpload } from '@mui/icons-material';
import { baseUrl } from '../../../axios';
import { useForm } from 'react-hook-form';
import Colors from '../../Assets/Styles/Colors';
import styled from '@emotion/styled';

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default function UFormDialog(props) {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const { open, handleClose, title, label, type, data, action, handleFileUpload, image, setImage, status, setStatus } = props;
  console.log("🚀 ~ UFormDialog ~ status:", status)
  console.log("🚀 ~ UFormDialog ~ data:", data)

  const defaultData = async () => {
    setValue("name", data?.name);
    setStatus(data?.isActive)
    if (label == "Category Name") {
      setImage(data?.image);
    }
  }

  useEffect(() => {
    if (data) {
      defaultData();
    }
  }, [data])

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        component={"form"}
        onSubmit={handleSubmit(action)}
        sx={{ width: "100%" }}
        PaperProps={{
          style: {
            minWidth: 400
          }
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={2}>
            <Grid item md={12}>
              <Grid container>
                <Grid item md={9}>
                  <Box>
                    <TextField
                      autoFocus
                      label={label}
                      fullWidth
                      variant="standard"
                      {...register("name", {
                        required: `Please enter ${label}`
                      })}
                      helperText={errors?.name?.message}
                      error={errors?.name && true}
                    />
                  </Box>
                </Grid>
                <Grid item md={3}>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          checked={status}
                          onChange={(e) => setStatus(e.target.checked)}
                        />
                      }
                      label={"Status"}
                      sx={{ flexDirection: "column-reverse" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {(label == "Category Name" || label == "Service Name") && (type == "adbazaar" || type == "adpro") && (
              <Grid item md={12}>
                {image ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "150px",
                        height: "120px",
                        objectFit: "contain"
                      }}
                    />
                    <Box>
                      <IconButton onClick={() => setImage("")}>
                        <Close />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <Fragment>
                    <input
                      multiple
                      type="file"
                      accept="image/*"
                      style={{
                        opacity: "0",
                        outline: "none",
                        background: "white",
                        cursor: "inherit",
                        display: "none",
                      }}
                      id="uploadImages"
                      onInput={(event) => {
                        handleFileUpload(event.target.files[0]);
                      }}
                      {...register("image", {
                        required:
                          image == "" ? "upload image" : false,
                      })}
                    />
                    <label
                      htmlFor="uploadImages"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        width: "100%",
                        height: "200px",
                        border: errors?.image?.message
                          ? `1px solid ${Colors.primary}`
                          : "1px solid #c4c4c4",
                        borderRadius: "4px",
                      }}
                    >
                      <CloudUpload
                        sx={{
                          display: "block",
                          fontSize: "38px",
                          color: errors?.image?.message
                            ? "#d32f2f"
                            : Colors.success,
                          cursor: "pointer",
                          "&:hover": {
                            color: Colors.secondary,
                            transition: "0.3s ease-in-out",
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          color: errors?.image?.message ? "#d32f2f" : Colors.gray,
                        }}
                      >
                        {errors?.image ? errors?.image?.message : "Upload Image"}
                      </Typography>
                    </label>
                  </Fragment>
                )}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}